import { Col, Row, Table } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import CartApi from 'apis/CartApi';
import { DownloadIcon } from 'assets/svg';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import formatDateWithTime from 'utils/formatDateWithTime';
import { openNotificationWithIcon } from 'utils/notification';
import * as XLSX from 'xlsx';

type FixedType = 'left' | 'right' | boolean;

interface Iprops {
  cart: any;
}

export default function PreOrderStoreRegisted(props: Iprops) {
  const history = useHistory();

  const queryParam = useQueryParam();
  const [page, setPage] = useState(parseInt(queryParam.get('page') + '') || 1);
  const [page_size, setPage_size] = useState(
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE
  );

  const { cart } = props;

  const [listOrderShop, setListOrderShop] = useState<any>();
  const [excelDownloadList, setExcelDownloadList] = useState<any>();
  const [total, setTotal] = useState<number>();

  useEffect(() => {
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
  }, [page, page_size]);

  const params = {
    plant_code: cart?.plant_code,
    cart_code: cart?.cart_code,
    page: page,
    page_size: page_size,
  };

  const { isLoading: getListOrderShopLoading } = useQuery(
    ['getListOrderShop'],
    () =>
      CartApi.getListOrderShop(params)
        .then((res) => {
          setListOrderShop(res?.data);
          setTotal(res?.total);
        })
        .catch((err) => {
          console.log('lỗi', err);
        })
  );

  const { isLoading: getExcelDownloadListLoading } = useQuery(
    ['getExcelDownloadList'],
    () =>
      CartApi.getListOrderShop({
        plant_code: cart?.plant_code,
        cart_code: cart?.cart_code,
        page: 1,
        page_size: total,
      })
        .then((res) => {
          setExcelDownloadList(res?.data);
        })
        .catch((err) => {
          console.log('lỗi', err);
        })
  );

  const convertToStatusName = (status: number) => {
    switch (status) {
      case 0:
        return 'Mới tạo';
      case 1:
        return 'CHT Duyệt và gửi CN';
      case 2:
        return 'CN Duyệt';
      case 3:
        return 'CN Từ chối';
      case 4:
        return 'HS Duyệt';
      case 5:
        return 'HS Từ chối';
      default:
        return '';
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã cửa hàng',
      dataIndex: 'ma_cua_hang',
      width: 150,
    },
    {
      title: 'Tên cửa hàng',
      dataIndex: 'ten_cua_hang',
      width: 200,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'order_status',
      width: 200,
      render: (text, record, index) => convertToStatusName(text),
    },
    {
      title: 'SL mẫu kế hoạch',
      //   dataIndex: 'id',
      width: 200,
    },
    {
      title: 'SL mẫu đăng ký',
      dataIndex: 'sl_dk_mau',
      width: 200,
    },
    {
      title: 'Vốn Min đăng ký',
      dataIndex: 'von_min',
      width: 200,
      render: (text, record, index) => formatCurrencyVND(text),
    },
    {
      title: 'Vốn Max kế hoạch',
      //   dataIndex: 'id',
      width: 200,
    },
    {
      title: 'Vốn Max đăng ký',
      dataIndex: 'von_max',
      width: 200,
      render: (text, record, index) => formatCurrencyVND(text),
    },
    {
      title: 'Min kế hoạch (món)',
      //   dataIndex: 'id',
      width: 200,
    },
    {
      title: 'Min đăng ký (món)',
      dataIndex: 'sl_dk_min',
      width: 200,
    },
    {
      title: 'Max kế hoạch (món)',
      //   dataIndex: 'id',
      width: 200,
    },
    {
      title: 'Max đăng ký (món)',
      dataIndex: 'sl_dk_max',
      width: 200,
    },
    {
      title: 'Quận, Huyện',
      dataIndex: 'district',
      width: 200,
    },
    {
      title: 'Tier',
      dataIndex: 'tier_name',
      width: 100,
    },
    {
      title: 'Mô hình kinh doanh',
      dataIndex: 'mo_hinh_kinh_doanh',
      width: 200,
    },
    {
      title: 'Cấp cửa hàng',
      dataIndex: 'cap_cua_hang',
      width: 150,
    },
    {
      title: 'Ngày đăng ký',
      dataIndex: 'created_at',
      width: 150,
      render: (text, record, index) => formatDateWithTime(text),
    },
    {
      title: 'Ngày phê duyệt',
      width: 150,
      dataIndex: 'approve_date',
      render: (text, record, index) => formatDateWithTime(text),
    },
    {
      title: 'Người phê duyệt',
      //   dataIndex: 'id',
      width: 200,
    },
    {
      title: 'Lần phê duyệt',
      //   dataIndex: 'id',
      width: 150,
    },
    {
      title: '',
      fixed: 'right' as FixedType,
      width: 0.1,
      //   render: (record: any) => (
      //     <div className="flex justify-around">
      //       <button
      //         onClick={() => {
      //           history.push(`/department-approval/detail/${record.id}`);
      //         }}
      //       >
      //         <EyeIcon />
      //       </button>
      //     </div>
      //   ),
    },
  ];

  const generateExcel = () => {
    const data = [];

    if (excelDownloadList.length == 0) {
      openNotificationWithIcon(
        'error',
        'Không thể tải file Excel',
        'Không có cửa hàng đăng kí'
      );
    } else {
      const headerRow = columns.map((column) => {
        return column.title;
      });
      data.push(headerRow);

      excelDownloadList.forEach((shop: any, key: number) => {
        const rowData = columns.map((column) => {
          if (column.dataIndex === 'id') {
            return key + 1;
          }
          if (column.dataIndex === 'order_status') {
            return convertToStatusName(shop[column.dataIndex]);
          }
          if (column.dataIndex === 'von_min') {
            return formatCurrencyVND(shop[column.dataIndex]);
          }
          if (column.dataIndex === 'von_max') {
            return formatCurrencyVND(shop[column.dataIndex]);
          }
          if (column.dataIndex === 'created_at') {
            return formatDateWithTime(shop[column.dataIndex]);
          }
          if (column.dataIndex === 'approve_date') {
            return formatDateWithTime(shop[column.dataIndex]);
          }

          return shop[column.dataIndex];
        });

        data.push(rowData);
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `danh_sach_cua_hang.xlsx`);
    }
  };

  return (
    <Content>
      <Row
        style={{
          marginBottom: '20px',
        }}
        justify={'end'}
      >
        <Col>
          <Button
            bgColor="border-primary-50"
            color="text-primary-50"
            onClick={() => {
              generateExcel();
            }}
          >
            <DownloadIcon />
            Tải file Excel
          </Button>
        </Col>
      </Row>

      <Table
        rowKey={(record) => record.id}
        columns={columns}
        scroll={{ x: 958 }}
        className="customTable"
        dataSource={listOrderShop}
        loading={getListOrderShopLoading || getExcelDownloadListLoading}
        // rowSelection={rowSelection}
        pagination={{
          className: 'flex items-center',
          current: page,
          pageSize: page_size,
          total: total,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPage_size(pageSize);

            history.push('/preorder/edit', {
              cart: cart,
              page: page,
              page_size: pageSize,
            });
          },
        }}
      />
    </Content>
  );
}
